<template>
    <div v-if="page" class="partner-with-us-page">

        <div class="hero-banner">
            <div class="container text-center white--text">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-13"
                >
                    <v-col cols="12" lg="9" class="pa-lg-0">
                        <h1 v-html="page.title"></h1>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-10"
                >
                    <v-col cols="10" sm="8" md="7" lg="6" class="pa-lg-0">
                        <p v-html="page.mainDescription"></p>
                    </v-col>
                </v-row>

                <v-row class="ma-0 mb-2 mb-md-6">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToCallToAction"
                        >
                            <span>List Your Property</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="benefits-section section">
            <div class="content">
                <v-row
                    justify="center"
                    class="mb-4"
                >
                    <v-col cols="12" lg="8" class="pa-lg-0">
                        <h2>{{ page.listingIconsTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="mb-6 mb-md-12"
                >
                    <v-col cols="12" sm="11" md="8" lg="7" class="pa-lg-0">
                        <p>{{ page.listingIconsDescription }}</p>
                    </v-col>
                </v-row>

                <v-row
                    v-if="page.property_partner_listing_icons"
                    justify="center"
                    class="benefit-icons mb-12"
                >
                    <v-col
                        v-for="(listingIcon, i) in page.property_partner_listing_icons"
                        :key="i"
                        cols="6"
                        md="4"
                        lg="2"
                    >
                        <v-img
                            :src="getImageUrl(listingIcon.icon)"
                            :alt="listingIcon.title"
                            width="136"
                            class="benefit-icon mb-4"
                        ></v-img>
                        <p>{{ listingIcon.title }}</p>
                    </v-col>
                </v-row>

                <v-row class="mb-2 mb-md-6">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToCallToAction"
                        >
                            <span>List Your Property</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="pricing-section section section-dark">
            <div class="content">
                <v-row
                    justify="center"
                    class="mb-4"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h2>{{ page.partnerPricingTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="mb-6 mb-md-12"
                >
                    <v-col cols="12" sm="10" md="7" class="px-md-5">
                        <p v-html="page.partnerPricingDescription"></p>
                    </v-col>
                </v-row>

                <v-row
                    v-if="page.property_partner_pricing_cards"
                    justify="center"
                    align="stretch"
                    class="pricing-options"
                >
                    <v-col
                        v-for="(card, i) in page.property_partner_pricing_cards"
                        :key="i"
                        cols="12"
                        sm="9"
                        md="6"
                        lg="4"
                        class="pricing-option mb-4"
                    >
                        <v-card
                            flat
                            class="pricing-card"
                            :class="card.class"
                        >
                            <v-card-text class="pricing-card-content">
                                <div class="card-top px-12 pt-9">
                                    <h3>{{ card.title }}</h3>
                                    <h3>{{ card.description }}</h3>
                                    <ul>
                                        <li
                                            v-for="(detail, i) in card.propertyPartnerDetails"
                                            :key="i"
                                            :class="detail.class"
                                        >
                                            {{ detail.title }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="card-bottom">
                                    <div class="card-price px-12 pb-5">
                                        <h4>{{ card.price }}</h4>
                                        <p>{{ card.priceDescription }}</p>
                                    </div>

                                    <v-btn
                                        depressed
                                        class="price-btn"
                                        :href="`/partner-with-us-sign-up/${card.price.replace(/\D/g, '')}`"
                                    >
                                        <span>Select</span>
                                    </v-btn>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="testimonials-section section">
            <div class="content">
                <v-row
                    justify="center"
                    class="mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h3>{{ page.testimonialsTitle }}</h3>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="logo-carousel ma-0 mb-4 mb-md-12"
                >
                    <SchoolLogoMarquee
                        :logos="propertyLogos"
                        :animation-speed="100"
                    />
                </v-row>

                <TestimonialsCarousel
                    v-if="testimonials"
                    :testimonials-data="testimonials"
                    class="text-left"
                />

                <v-row class="mb-4 mb-md-8 mb-md-12">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToCallToAction"
                        >
                            <span>List Your Property</span>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4"
                >
                    <v-col cols="12" md="8" lg="7" class="pa-lg-0">
                        <h2>{{ page.getStartedTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4"
                >
                    <v-col cols="12" sm="10" md="8" class="px-lg-6">
                        <p>{{ page.getStartedDescription }}</p>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4"
                >
                    <SimpleSteps
                        v-if="simpleSteps"
                        page-name="partner-with-us-school"
                        :call-to-actions="simpleSteps"
                    />
                </v-row>
            </div>
        </div>

        <div id="call-to-action" class="call-to-action section section-dark">
            <div class="content my-0">
                <v-row>
                    <v-col cols="12" class="call-to-action-content">
                        <v-row class="ma-0 mb-4">
                            <v-col cols="12" class="pa-md-0 text-center">
                                <h2>{{ page.contactTitle }}</h2>
                            </v-col>
                        </v-row>

                        <v-row class="ma-0">
                            <v-col cols="12"  class="pa-md-0 text-center">
                                <p v-html="page.contactDescription"></p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { email, maxLength, required } from 'vuelidate/lib/validators';
import SchoolLogoMarquee from '@/components/SchoolLogoMarquee';
import SimpleSteps from '@/components/SimpleSteps';
import TestimonialsCarousel from '@/components/TestimonialsCarousel';
import SiteService from '@/services/site.service';
import { flattenObj, formatPhoneNumber } from '@/utils/utils';

export default {
    name: 'PartnerWithUs',

    components: {
        SchoolLogoMarquee,
        SimpleSteps,
        TestimonialsCarousel,
    },

    data() {
        return {
            baseMediaPath: process.env.VUE_APP_CMS_BASE_URL ?? 'https://cms.edurent.com',

            contactForm: {
                city: '',
                emailAddress: '',
                name: '',
                phone: '',
                propertyName: '',
                state: null,
                allow_subscription: false,
            },

            page: {
                id: null,

                title: '',
                mainDescription: '',

                listingIconsTitle: '',
                listingIconsDescription: '',
                property_partner_listing_icons: null,

                partnerPricingTitle: '',
                partnerPricingDescription: '',
                property_partner_pricing_cards: null,

                testimonialsTitle: '',
                propertyLogos: null,
                testimonials: null,

                getStartedTitle: '',
                getStartedDescription: '',
                partnerSteps: null,

                contactTitle: '',
                contactDescription: '',
            },
        }
    },

    validations: {
        contactForm: {
            city: { required },
            emailAddress: { required, email },
            name: { required, maxLength: maxLength(30) },
            propertyName: { required },
            state: { required },
            allow_subscription: { required },
        },
    },

    computed: {
        formErrors() {
            const errors = {
                city: [],
                email: [],
                name: [],
                property: [],
                state: [],
            };

            if (! this.$v.contactForm.$anyDirty) {
                return errors;
            }

            if (this.$v.contactForm.city.$dirty) {
                ! this.$v.contactForm.city.required && errors.city.push('City is required');
            }

            if (this.$v.contactForm.emailAddress.$dirty) {
                ! this.$v.contactForm.emailAddress.email && errors.email.push('Must be a valid E-mail Address');
                ! this.$v.contactForm.emailAddress.required && errors.email.push('E-mail Address is required');
            }

            if (this.$v.contactForm.name.$dirty) {
                ! this.$v.contactForm.name.maxLength && errors.name.push('Name is must be at most 30 characters long');
                ! this.$v.contactForm.name.required && errors.name.push('Name is required');
            }

            if (this.$v.contactForm.propertyName.$dirty) {
                ! this.$v.contactForm.propertyName.required && errors.property.push('Property/Company name is required');
            }

            if (this.$v.contactForm.state.$dirty) {
                ! this.$v.contactForm.state.required && errors.state.push('State is required');
            }

            return errors;
        },

        isPageLoaded() {
            return this.page?.id > 0;
        },

        propertyLogos() {
            if (! this.isPageLoaded || this.page.propertyLogos == null) {
                return [];
            }

            return this.page.propertyLogos.map((logo) => {
                return {
                    id: logo.id,
                    url: logo.image.url,
                    alternativeText: logo.image.alternativeText,
                };
            });
        },

        simpleSteps() {
            if (! this.isPageLoaded || this.page.partnerSteps == null) {
                return [];
            }

            return this.page.partnerSteps.map((step) => {
                return {
                    title: step.title,
                    icon: step.image,
                    description: step.content,
                };
            });
        },

        states() {
            return this.$store.getters.getBusiness?.countries?.[0]?.states || [];
        },

        testimonials() {
            if (! this.isPageLoaded || this.page.testimonials == null) {
                return [];
            }

            return this.page.testimonials.map((testimonial) => {
                return {
                    name: testimonial.title,
                    quote: testimonial.content,
                };
            });
        },
    },

    beforeMount() {
        this.init();
    },

    methods: {
        /**
         * Clear the vuelidate validation for the call to action form.
         * @returns {void}
         */
        clearForm() {
            this.$v.contactForm.$reset();

            this.contactForm.city = '';
            this.contactForm.emailAddress = '';
            this.contactForm.name    = '';
            this.contactForm.phoneNumber = '';
            this.contactForm.propertyName = '';
            this.contactForm.state = null;
        },

        /**
         * Format the phone number and update the contact form validation.
         */
        formatPhoneNumber() {
            this.$v.contactForm.phoneNumber.$touch();
            this.contactForm.phoneNumber = formatPhoneNumber(this.contactForm.phoneNumber);
        },

        /**
         * Attempt to get the file path from the specified image object.
         * @param {Object} image
         * @returns {string}
         */
        getImageUrl(image) {
            try {
                return this.baseMediaPath + image.url;
            } catch (thrown) {
                return '';
            }
        },

        /**
         * Get the page data from the CMS and if the data is not available, navigate back to the default page.
         * @returns {Promise<Route|void>}
         */
        async init() {
            // Set the menu to transparent
            this.$store.commit('setHeaderMenuState', 'transparent');

            // Get the page data
            const response = await SiteService.getPartnerWithUsPage();
            if (response == null) {
                return this.$router.push('/');
            }

            // Check that the response returned the page with id, otherwise return to the homepage
            const page = flattenObj(response);
            if (page == null || page?.id == null) {
                return this.$router.push('/');
            }

            this.page = page;
        },

        /**
         * Scroll to the call-to-action section of the page.
         */
        scrollToCallToAction() {
            const offset = this.$vuetify.breakpoint.mdAndDown ? -65 : 0;

            this.$scrollTo('#call-to-action', 500, {
                offset,
            });
        },

        /**
         * Attempt to submit the call to action form.
         * @returns {void}
         */
        submit() {
            // Handle the form validation errors, if any exist
            this.$v.contactForm.$touch();
            if (this.$v.contactForm.$invalid) {
                // Scroll to the contact form, just in case
                this.scrollToCallToAction();

                // Show a snackbar message to the user about the form errors
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'A mandatory field is missing. Please look through the '
                        + 'form and fix the field(s) highlighted in red',
                    color: 'red'
                });

                // Return without submitting the form
                return;
            }

            // The form is valid, so send the information
            this.$store.dispatch('sendGetInfoMessage', {
                city: this.contactForm.city,
                company: this.contactForm.propertyName,
                email: this.contactForm.emailAddress,
                name: this.contactForm.name,
                phone: this.contactForm.phoneNumber,
                state: this.contactForm.state,
            }).then(() => {
                this.clearForm();
            })
        },
    },
};
</script>

<style scoped lang="scss">
/** Generic Page styles */
::v-deep .content>.row {
    width: 100%;
    margin: 0;
}

div.partner-with-us-page {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

    .v-btn {
        height: 45px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: normal;
        text-transform: capitalize;
        padding: 0 25px;
    }
}

div.hero-banner .container,
div.section .content {
    height: fit-content;
    width: 90%;
    max-width: 1505px;
    padding: 0 10px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    word-spacing: 1px;
    z-index: 2;
}

/** Hero Banner styles */
div.hero-banner {
    padding-top: 160px;
    padding-bottom: 55px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 630px;
    min-height: 567px;
    background-image: url("../../src/assets/media/property-banner.jpg");
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;

    h1 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 64px;
        line-height: 72px;
        max-width: 1300px;
        margin: auto;

        @media (max-width: 1400px) {
            font-size: clamp(30px, 3em, 64px);
            line-height: 1.125;
        }

        @media (max-width: 575px) {
            font-size: 30px;
        }
    }

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(10, 10, 10, 0.75);
        z-index: 1;
    }

    @media (max-width: 1264px) {
        max-height: 720px;
        min-height: 630px;
        padding-top: 170px;
    }

    @media (max-width: 1024px) {
        padding: 0;

        h1 {
            font-size: clamp(30px, 3em, 50px);
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media (max-width: 768px) {
        padding-top: 100px;
        padding-bottom: 70px;
        min-height: 200px;
        height: auto;

        h1 {
            font-size: clamp(30px, 2em, 64px);
        }
    }
}

/** Section styles */
div.section {
    font-family: 'Poppins';
    font-style: normal;
    padding: 100px 0;

    .content {
        h2, h3, h4, p {
            color: #000000;
        }

        h2 {
            font-weight: 700;
            font-size: 48px;
            line-height: 1.5;
            margin: 0 auto;
        }

        h3 {
            font-weight: 700;
            font-size: 28px;
            line-height: 1.5;
            margin: 0 auto;
        }

        h4 {
            font-weight: 700;
            font-size: 18px;
            line-height: 1.5;
            margin: 10px auto;
        }

        @media (max-width: 1400px) {
            h2, h3, h4 {
                line-height: 1.25;
            }

            h2 {
                font-size: clamp(26px, 2.5em, 48px) !important;
            }

            h3 {
                font-size: clamp(20px, 2em, 28px) !important;
            }
        }

        @media (max-width: 1024px) {
            width: 100%;
            padding-left: 20px;
            padding-right: 20px;

            h2, h3, h4 {
                padding-left: 0;
                padding-right: 0;
            }

            h2 {
                font-size: clamp(26px, 2.5em, 40px) !important;
            }

            h3 {
                font-size: clamp(20px, 2em, 26px) !important;
            }
        }

        @media (max-width: 768px) {
            h2, h3, h4 {
                line-height: 1.125 !important;
            }

            h2 {
                font-size: clamp(26px, 2.5em, 32px) !important;
            }

            h3 {
                font-size: clamp(20px, 2em, 22px) !important;
            }
        }

        @media (max-width: 575px) {
            h2 {
                font-size: 26px !important;
            }

            h3 {
                font-size: 20px !important;
            }
        }
    }

    &.section-dark {
        background-color: #373e55;

        .content {
            h2, h3, h4, p {
                color: #FFFFFF;
            }
        }
    }
}

/** Benefits section styles */
div.benefits-section {
    .benefit-icons {
        .benefit-icon {
            margin: 0 auto;
        }

        p {
            font-weight: bold;
            padding: 0 17px;
        }
    }
}

/** Pricing section styles */
div.pricing-section {
    .pricing-options {
        .pricing-option {
            .pricing-card {
                height: 100%;
                width: 100%;
                border-radius: 15px;
                border-width: 0;

                .pricing-card-content:hover {
                    h3, h4 {
                        color:black;
                    }
                    &.sub-title {
                        color: #2D76E3;
                    }

                    h4, p {
                        color: #2D76E3;
                    }


                    .price-btn {
                        background-color: #2D76E3;
                    }
                }
                .pricing-card-content {
                    height: 100%;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    h3, h4 {
                        text-transform: none;
                        font-size: 1.5rem;
                        line-height: 2.3rem;
                        color: #BABABA;
                        margin: 0;
                    }


                    p {
                        font-size: 1rem;
                        line-height: 2rem;
                        color: #BABABA;
                    }

                    ul {
                        margin: 1rem auto;
                        list-style: none;
                        padding-left: 0;
                        padding-bottom: 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        li {
                            position: relative;
                            width: 50%;
                            min-width: 300px;
                            text-align: left;
                            padding-left: 34px;
                            font-size: 1rem;
                            line-height: 2rem;
                            margin-bottom: 10px;
                            color: #000000;

                            &.sub-title {
                                text-align: center;
                                color: #2D76E3;
                                font-weight: bold;
                                letter-spacing: 1px;
                                padding-left: 0;

                                &::before {
                                    content: none;
                                }
                            }

                            &::before {
                                content: "";
                                position: absolute;
                                width: 14px;
                                height: 34px;
                                left: 9px;
                                top: 8px;
                                background-image: url('../../src/assets/icons/green_check.png');
                                background-size: contain;
                                background-repeat: no-repeat;
                            }
                        }


                        @media (min-width: 960px) {
                            display: inherit;

                            li {
                                width: 100%;
                            }
                        }
                    }

                    .price-btn {
                        width: 100%;
                        border-radius: 0 0 15px 15px;
                        margin-bottom: -1px;
                        margin-left: -1px;
                        margin-right: -1px;
                        color: #fff;
                        background-color: #BABABA;
                    }
                }

                &.highlighted {
                    .pricing-card-content {
                        h3 {
                            color: #000000;
                        }

                        h4, p {
                            color: #2D76E3;
                        }

                        .price-btn {
                            background-color: #2D76E3;

                            &:hover {
                                background-color: #2D76E3;
                            }
                        }
                    }
                }
            }

            @media (min-width: 1500px) {
                padding: 0 25px;
            }
        }
    }
}

/** Testimonials section styles */
div.testimonials-section {
    .logo-carousel {
        margin-top: 100px !important;
        min-height: 72px;
        position: relative;
        opacity: 0.5;

        ::v-deep .logo-marquee {
            position: absolute;
            background-color: #FFFFFF;

            img {
                filter: invert(50%);
            }
        }

        @media (max-width: 1024px) {
            margin-top: 48px !important;
        }
    }

    ::v-deep .steps-content {
        margin-top: 65px;

        p {
            width: auto;
            max-width: 325px;
        }

        img {
            width: auto;
        }
    }
}

/** Call to Action section styles */
div.call-to-action {
    font-family: 'Poppins';
    font-style: normal;
    padding: 100px 180px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    // max-height: 1300px;
    min-height: 300px;
    background-image: url("../../src/assets/media/area-guide-footer.png");
    background-position: top center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;

    .call-to-action-content {
        padding: 0;

        h2 {
            font-weight: 700;
            font-size: 48px;
            line-height: 1.5;
            margin: 0 auto;
            color: #FFFFFF;
        }

        p {
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
        }
    }

    .call-to-action-form {
        padding: 15px;
        border-radius: 15px;
        background-color: #e3e4e5;

        h3 {
            font-size: 26px;
        }

        label {
            font-weight: 700;
            font-size: 13px;
            letter-spacing: 0;
            color: #000000;
        }

        .v-input, .v-btn {
            max-height: 76px;
            min-height: 46px;
        }
    }

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(10, 10, 10, 0.75);
        z-index: 1;
    }

    @media (max-width: 1400px) {
        background-size: cover !important;
    }

    @media (max-width: 1024px) {
        padding: 75px 0;
    }

    @media (max-width: 768px) {
        padding: 50px 0;
    }

    @media (max-width: 655px) {
        padding: 10px 0;
    }
}

/** Generic Responsive styles */
@media (max-width: 1024px) {
    div.hero-banner .container,
    div.call-to-action .content {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
}

@media (max-width: 768px) {
    div.hero-banner .container,
    div.section .content {
        max-width: 100%;
    }
}
</style>
